// extracted by mini-css-extract-plugin
export default {"zr-setting-box":"GlobalSettings_zr-setting-box__x2H6g","zr-save-setting-btn":"GlobalSettings_zr-save-setting-btn__npDMz"};